<template>
  <div>
    <ion-col>
      <div class="home-upper allow-select">
        <h1>A Law Student's Companion</h1>
        <p>Search Supreme Court cases and Philippine laws. Create casebooks, notes, digests, and reviewers. Share your materials with other users.</p>
      </div>
    </ion-col>
    <ion-grid>
        <ion-row class="dashboard-item-button-row">
            <ion-col class="dashboard-item-button-container" size="6" size-md="3" size-lg="3" v-for="(item, idx) in menuItems" :key="idx">
              <button @click="onclick(item.route)" class="dashboard-item-button">
                <div class="dashboard-item-button-inner">
                  
                  <img :src="item.photo" />
                  
                  <span>
                      {{item.title}}
                  </span>
                </div>
              </button>
            </ion-col>
        </ion-row>
    </ion-grid>
    <div padding>
        <ion-item lines="none" v-if="recentCasesItems.length > 0 || recentLawsItems.length > 0">
          <ion-label class="search-label">
            Recently Opened
          </ion-label>
        </ion-item>
        <div v-if="recentCasesItems.length > 0">
            <ion-item>
              <ion-label class="search-label">
                Cases
              </ion-label>
            </ion-item>

          <ion-list>
            <ion-item
              detail
              button
              v-for="(c, idx) in recentCasesItems"
              :key="idx"
              @click="onItemClick('cases', c.id)"
            >
              <ion-grid when="sm" style="width:100%">
                <ion-row>
                  <ion-col size-sm="3" size="12">
                    <span>{{ c.shortGR }}</span>
                    <ion-note class="no-margin">{{ formatDate(c.date) }}</ion-note>
                  </ion-col>
                  <!-- <ion-col size-sm="2" size="12"></ion-col> -->

                  <ion-col size-sm="7" size="12">
                    <h2 class="list-title" v-html="c.shortTitle"></h2>
                  </ion-col>

                  <ion-col size-sm="2" size="12"
                    ><span>{{ c.ponente }}</span></ion-col
                  >
                </ion-row>
                <ion-row v-if="c.abstract">
                  <ion-col v-html="c.abstract"></ion-col>
                </ion-row>
              </ion-grid>
            </ion-item>
          </ion-list>
        </div>
        <div v-if="recentLawsItems.length > 0">
            <ion-item>
              <ion-label class="search-label">
                Laws
              </ion-label>
            </ion-item>

            <ion-list>
              <ion-item
                detail
                button
                v-for="(c, idx) in recentLawsItems"
                :key="idx"
                @click="onItemClick('laws', c.id)"
              >
                <ion-grid when="sm" style="width:100%">
                  <ion-row>
                    <ion-col size-sm="3" size="12"
                      ><p class="no-margin">{{ c.ref }}</p></ion-col
                    >

                    <ion-col size-sm="7" size="12">
                      <h2 class="list-title" v-html="c.shortTitle"></h2>
                    </ion-col>

                    <ion-col size-sm="2" size="12">
                      <span>{{ formatDate(c.date) }}</span>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-item>
            </ion-list>
        </div>
        <ion-col>
          <div class="home-sections allow-select">
            <h3><b style="color: var(--ion-color-primary);">Lawyerly</b> is more than just a search engine.</h3>
            <p>Discover the many tools it has to offer. Save time in finding, formatting, and organizing cases and laws. Read your casebooks as law students should. Review, and recall what you have read and studied. Prepare your own review materials for the exams. Collaborate with your classmates. Share what you have learned.</p>
          </div>
        </ion-col>
        <ion-col>
          <div class="home-sections allow-select">
              <h2 style="text-align: center;">Search Cases and Laws</h2>
              <p>Lawyerly is a web-based legal research platform where you can access all Supreme Court cases, relevant laws and implementing rules and regulations. It has a versatile and advanced searching capability that lets you search for cases, laws, doctrines using case citations, General Register numbers, keywords, or hashtags with accurate results.</p>
          </div>
        </ion-col>
        <ion-col>
          <div class="home-sections allow-select">
            <h2 style="text-align: center;">Organize with Casebooks</h2>
            <p>Lawyerly users can create a casebook wherein they can organize cases or laws by topics and sub-topics. Adding cases is easy with the "Add to Casebook" button. Casebooks are interactive where you can track cases they have read. And they can also quickly view the principles cited in these cases at the click of a button.</p>
          </div>
        </ion-col>
       <ion-col>
          <div class="home-sections allow-select">
            <h2 style="text-align: center;">Digests</h2>
            <p>Creating your own digest is easy, even without typing a single word. Simply open a case and start highlighting text as FACTS, ISSUES, RULING, PRINCIPLES. Your digest will be automatically created when you click on the Digest button.</p>
          </div>
       </ion-col>
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns';

export default {
  computed: {
    menuItems() {
      return this.$store.state.ui.menu.filter((i)=>(i.title !== "Dashboard" && i.title !== "Settings"));
    },
    recentCasesItems() {
      const items = this.$store.state.history.recent.cases.slice().reverse();
      return items.slice(0, 8);
    },
    recentLawsItems() {
      const items = this.$store.state.history.recent.laws.slice().reverse();
      return items.slice(0, 8);
    }
  },
  methods: {
    onclick(route) {
      this.$router.push(route);
    },
    recentItem(type, key) {
      return this.$store.state.history.recent[type][key];
    },
    onItemClick(type, id) {
      this.$router.push(`/${type}/${id}`);
    },
    formatDate(date) {
      return format(new Date(date), "MMM-dd-yyyy");
    }
  },
  mounted() {
    this.$store.commit("ui/setHeaderTitle", "Lawyerly");
  }
};
</script>
<style scoped>
.dashboard-item-button {
  width: 100%;
  position: relative;
  background: #ffffff;
}
.dashboard-item-button:hover {
  background: #e0e0e0;
}

.dashboard-item-button-inner {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dashboard-item-button:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.dashboard-item-button-inner img {
  width: 35%;
}

.dashboard-item-button-inner span {
  font-size: 1.3em;
  margin-top: 1em;
}

h2.list-title {
  font-size: 14pt;
  margin: 0px;
}

.dashboard-item-button-row {
 justify-content: center;
}

@media (min-width: 768px) {

  .dashboard-item-button-container {
    max-width: 150px !important;
  }
}

.home-upper {
  padding: 1em 0;
  text-align: center;
}

.home-upper h1{
  margin: 0;
}

.home-sections h2{
  color: var(--ion-color-primary);
}

.home-sections {
  padding: 1.5em 0 0.25em 0;
}

ion-note.no-margin {
  margin: 0px 0.5em;
}
</style>

